<template>
  <div class="ServiceList">
    <div>
      <div class="flex">
        <div class="lt-area flex-auto">
          <div class="inline">
            <APeriodSelector
              ref="period"
              :value="search_period"
              hide-select
              @change="handleChangePeriod"
            />
          </div>
          <div class="inline">
            <el-button
              type="primary"
              size="mini"
              round
              v-shortkey="['f5']"
              @shortkey.native="handleClickSearch"
              @click="handleClickSearch"
              >검색(F5)</el-button
            >
          </div>
          <div class="search-left-space inline" />
          <div class="inline">
            <el-button size="mini" round @click="handleClickInit"
              >초기화</el-button
            >
          </div>
        </div>
      </div>
      <div class="flex">
        <div class="font-prop inline">거래처</div>
        <div class="inline">
          <el-input
            v-model="search_customer"
            class="input-with-select"
            size="mini"
            placeholder="거래처"
            :style="{ width: searchWidth }"
          >
          </el-input>
        </div>
        <div class="search-left-space inline" />
        <div class="font-prop inline" :style="{ width: '30px' }">주소</div>
        <div class="inline">
          <el-input
            v-model="search_address"
            class="input-with-select"
            size="mini"
            placeholder="주소"
            :style="{ width: searchWidth }"
          >
          </el-input>
        </div>
        <div class="search-left-space inline" />
        <div class="font-prop inline" :style="{ width: labelWidth }">
          A/S내용
        </div>
        <div class="inline">
          <el-input
            v-model="search_symptom"
            class="input-with-select"
            size="mini"
            placeholder="A/S내용"
            :style="{ width: searchWidth }"
          >
          </el-input>
        </div>
        <div class="search-left-space inline" />
        <div class="font-prop inline" :style="{ width: labelWidth }">
          처리내용
        </div>
        <div class="inline">
          <el-input
            v-model="search_action"
            class="input-with-select"
            size="mini"
            placeholder="처리내용"
            :style="{ width: searchWidth }"
          >
          </el-input>
        </div>
      </div>
      <div class="flex">
        <div class="lt-area flex-auto">
          <div class="search-top-space font-prop inline">담당자</div>
          <div class="search-top-space inline">
            <el-input
              v-model="search_charger"
              class="input-with-select"
              size="mini"
              placeholder="담당자"
              :style="{ width: searchWidth }"
            >
            </el-input>
          </div>
          <div class="search-left-space inline" />
          <div
            class="search-top-space font-prop inline"
            :style="{ width: '30px' }"
          >
            비용
          </div>
          <div class="search-top-space inline">
            <el-select
              v-model="search_free_flag"
              :style="{ width: searchWidth }"
            >
              <el-option
                v-for="item in free_flag_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
          <div class="search-left-space inline" />
          <div
            class="search-top-space font-prop inline"
            :style="{ width: labelWidth }"
          >
            연락처
          </div>
          <div class="search-top-space inline">
            <el-input
              v-model="search_tel"
              class="input-with-select"
              size="mini"
              placeholder="연락처"
              :style="{ width: searchWidth }"
            >
            </el-input>
          </div>
          <div class="search-left-space inline" />
          <div
            class="search-top-space font-prop inline"
            :style="{ width: labelWidth }"
          >
            비고
          </div>
          <div class="search-top-space inline">
            <el-input
              v-model="search_desc"
              class="input-with-select"
              size="mini"
              placeholder="비고"
              :style="{ width: searchWidth }"
            >
            </el-input>
          </div>
        </div>
        <div class="rt-area flex-fixed align-right">
          <el-button
            icon="fas fa-file-excel fa-lg"
            style="padding: 8px;"
            circle
            @click="handleClickExcel"
          ></el-button>
        </div>
      </div>
      <ATable
        ref="table"
        v-loading="loading"
        max-height="715px"
        buttons-width="250px"
        :data="items"
        :row-class-name="tableRowClassName"
        :disable_insert="!has_grant_write"
        hideTopPanel
        hide-pagination
        border
        @clicked-create="handleClickedCreate"
        @cell-click="handleCellClick"
      >
        <el-table-column
          :label="$t('lang.No')"
          type="index"
          :index="handleIndex"
          :width="$width.index"
          fixed
        />
        <el-table-column
          prop="request_date"
          :label="$t('lang.receipt_date')"
          :width="$width.date"
        />
        <el-table-column
          prop="install_date"
          label="설치일"
          :width="$width.date"
        />
        <el-table-column
          prop="service_date"
          :label="$t('lang.access_date')"
          :width="$width.date"
        />
        <el-table-column
          prop="customer_name"
          :label="$t('lang.customer')"
          width="120"
        />
        <el-table-column
          prop="customer_addr"
          :label="$t('lang.address')"
          width="350"
        />
        <el-table-column
          prop="customer_tel"
          :label="$t('lang.user_tel')"
          width="120"
        />
        <el-table-column
          prop="customer_tel2"
          :label="$t('lang.user_tel') + '2'"
          width="120"
        />
        <el-table-column
          prop="symptom"
          :label="$t('lang.fault_symptom')"
          width="350"
        />
        <el-table-column prop="action" label="처리내용" width="350" />
        <el-table-column prop="desc" label="비고" width="350" />
        <el-table-column
          prop="free_flag"
          label="비용"
          width="60"
          :formatter="resolveFreeFlag"
        />
        <el-table-column
          prop="charger"
          label="담당자"
          :width="$width.username"
        />
        <el-table-column
          prop="price"
          label="청구금"
          width="80"
          class-name="cell-number"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="collected_price"
          label="수금"
          width="80"
          class-name="cell-number"
          :formatter="util.numberFormat"
        />
        <el-table-column prop="collected_date" label="수금일" :width="120" />
        <el-table-column
          prop="created_user_name"
          :label="$t('lang.created_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="modified_user_name"
          :label="$t('lang.modified_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="created_at"
          :label="$t('lang.created_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="modified_at"
          :label="$t('lang.modified_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column label="명령" width="230" fixed="right">
          <template slot-scope="scope">
            <el-button
              size="mini"
              :disabled="!has_grant_write"
              @click="handleClickButtonSale(scope.row)"
              >처리</el-button
            >
            <el-button
              size="mini"
              :disabled="!has_grant_write"
              @click="handleClickButtonContract(scope.row)"
              >수주</el-button
            >
            <el-button
              size="mini"
              :disabled="!scope.row.price || !has_grant_write"
              @click="handleClickButtonCollect(scope.row)"
              >수금</el-button
            >
            <el-button
              size="mini"
              :disabled="!has_grant_write"
              @click="handleClickButtonCopy(scope.row)"
              >복사</el-button
            >
          </template>
        </el-table-column>
      </ATable>
    </div>
    <el-dialog
      custom-class="form-dialog"
      top="0"
      :title="$t('title.as_handle')"
      :visible.sync="dialog_visible"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      destroyOnClose
      @opened="handleOpened()"
    >
      <ServiceSaleForm
        ref="form"
        v-if="dialog_visible"
        :data="selectedData"
        :has_grant_write="has_grant_write"
        @completed="handleCompletedForm"
      />
    </el-dialog>
    <el-dialog
      custom-class="form-dialog"
      top="0"
      width="1200px"
      :title="$t('title.contract_reg')"
      :visible.sync="dialog2_visible"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      destroyOnClose
      @opened="handleOpened('form2')"
    >
      <ContractForm
        ref="form2"
        v-if="dialog2_visible"
        :data="contract"
        :has_grant_write="has_grant_write"
        @completed="handleCompletedContractForm"
      />
    </el-dialog>
    <el-dialog
      custom-class="form-dialog"
      top="0"
      :title="$t('title.collection')"
      :visible.sync="dialog3_visible"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      destroyOnClose
      @opened="handleOpened('form3')"
    >
      <ServiceCollect
        ref="form3"
        v-if="dialog3_visible"
        :data="selectedData"
        :contract="contract"
        :has_grant_write="has_grant_write"
        @change="handleChangeCollect"
        @completed="handleCompletedCollect"
      />
    </el-dialog>
  </div>
</template>

<script>
import { form_container } from "@/common/mixins/form_container";
import ServiceSaleForm from "./ServiceSaleForm";
// import ServiceManualSaleForm from "./ServiceManualSaleForm";
import ContractForm from "@/spa/Sale/ContractForm";
import ServiceCollect from "./ServiceCollect";

export default {
  name: "ServiceList",
  mixins: [form_container],
  components: {
    ServiceSaleForm,
    ContractForm,
    ServiceCollect,
  },
  data() {
    return {
      title: this.$t("title.as"),
      items: [],
      dialog_visible: false,
      selectedData: undefined,
      loading: false,
      search_period: { value: "0d" },
      dialog2_visible: false,
      contract: null,
      dialog3_visible: false,
      searchWidth: "150px",
      labelWidth: "50px",
      search_customer: "",
      fixed_search_customer: "",
      search_address: "",
      fixed_search_address: "",
      search_symptom: "",
      fixed_search_symptom: "",
      search_charger: "",
      fixed_search_charger: "",
      search_action: "",
      fixed_search_action: "",
      search_tel: "",
      fixed_search_tel: "",
      search_desc: "",
      fixed_search_desc: "",
      search_free_flag: "All",
      fixed_search_free_flag: "All",
    };
  },
  props: {
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    filterdData() {
      return this.items.filter((item) => {
        // 거래처
        if (
          !(
            this.fixed_search_customer === "" ||
            (item.customer_name !== null &&
              item.customer_name
                .toUpperCase()
                .indexOf(this.fixed_search_customer.toUpperCase()) > -1)
          )
        ) {
          return false;
        }
        // 주소
        if (
          !(
            this.fixed_search_address === "" ||
            (item.customer_addr !== null &&
              item.customer_addr
                .toUpperCase()
                .indexOf(this.fixed_search_address.toUpperCase()) > -1)
          )
        ) {
          return false;
        }
        // A/S내용
        if (
          !(
            this.fixed_search_symptom === "" ||
            (item.symptom !== null &&
              item.symptom
                .toUpperCase()
                .indexOf(this.fixed_search_symptom.toUpperCase()) > -1)
          )
        ) {
          return false;
        }
        // 처리내용
        if (
          !(
            this.fixed_search_action === "" ||
            (item.action !== null &&
              item.action
                .toUpperCase()
                .indexOf(this.fixed_search_action.toUpperCase()) > -1)
          )
        ) {
          return false;
        }
        // 담당자
        if (
          !(
            this.fixed_search_charger === "" ||
            (item.charger !== null &&
              item.charger
                .toUpperCase()
                .indexOf(this.fixed_search_charger.toUpperCase()) > -1)
          )
        ) {
          return false;
        }
        // 비용(유/무)
        if (
          !(
            this.fixed_search_free_flag === "All" ||
            (item.free_flag !== null &&
              item.free_flag === this.fixed_search_free_flag)
          )
        ) {
          return false;
        }
        // 연락처
        if (
          !(
            this.fixed_search_tel === "" ||
            (item.customer_tel !== null &&
              item.customer_tel.indexOf(this.fixed_search_tel) > -1) ||
            (item.customer_tel2 !== null &&
              item.customer_tel2.indexOf(this.fixed_search_tel) > -1)
          )
        ) {
          return false;
        }
        // 비고
        if (
          !(
            this.fixed_search_desc === "" ||
            (item.desc !== null &&
              item.desc
                .toUpperCase()
                .indexOf(this.fixed_search_desc.toUpperCase()) > -1)
          )
        ) {
          return false;
        }
        return true;
      });
    },
    free_flag_options() {
      return [
        { label: "All", value: "All" },
        { label: "무상", value: "Y" },
        { label: "유상", value: "N" },
      ];
    },
  },
  mounted() {
    // this.$nextTick(() => this.loadData());
    this.$nextTick(() => this.loadDataBySearchWord());
  },
  methods: {
    /**
     * frontend에서 검색 결과를 조건에 따라 filtering하여 출력하는 방법
     * A/S관리 정보는 대량의 정보가 아닐 것으로 판단하여
     * 검색 결과를 frontend에서 fintering하는 방식을 채택함
     * 만약,  A/S관리 정보가 대량이여서 동작이 느릴 경우,
     * 아래의 loadDataBySearchWord() 메소드를 이용하여
     * backend에 query를 통한 검색 결과 출력 방식으로 변경 필요
     */
    loadData() {
      this.loading = true;
      this.api.listService(this.period).then((res) => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }

        this.convertCollectedDate(res.data);

        this.handleSearchWord();
        this.items = res.data;
      });
    },
    /**
     * backend에서 조건을 전달하여 query를 통한 검색 결과 출력하는 방법
     * 테이블 속성 중 data 항목에 items 를 전달하면 됨
     * <ATable
     *   :data="items"
     * 그리고, handleClickSearch() 메소드에서 loadDataBySearchWord() 메소드를 사용
     */
    loadDataBySearchWord() {
      this.loading = true;
      let param = this.getSearchWord();
      this.api.listServiceBySearchWord(this.period, param).then((res) => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items = this.convertCollectedDate(res.data);
      });
    },
    convertCollectedDate(resData) {
      const result = [];
      for (let i = 0; i < resData.length; i++) {
        const item = { ...resData[i] };
        if (!item.collect_date) {
          item.collected_date = "";
        } else if (item.collect_date.length === 1) {
          item.collected_date = item.collect_date[0];
        } else {
          item.collected_date =
            item.collect_date[0] +
            "외 " +
            String(item.collect_date.length - 1) +
            "건";
        }
        result.push(item);
      }
      return result;
    },
    getSearchWord() {
      let param = {};
      param.customer_name = this.search_customer;
      param.customer_addr = this.search_address;
      param.symptom = this.search_symptom;
      param.action = this.search_action;
      param.charger = this.search_charger;
      param.free_flag = this.search_free_flag;
      param.customer_tel = this.search_tel;
      param.desc = this.search_desc;
      return param;
    },
    tableRowClassName({ row }) {
      if (row.free_flag !== "Y") {
        if (row.collected_price !== row.price) {
          return "danger-row";
        } else {
          return "success-row";
        }
      }
    },
    selectable(row) {
      return row.price;
    },
    resolveFreeFlag(row, column, value) {
      return value === "Y" ? "무상" : "유상";
    },
    handleChangePeriod(value) {
      this.period = value;
    },
    handleClickSearch() {
      if (!this.period.valid) {
        return;
      }
      // this.loadData();
      this.loadDataBySearchWord();
    },
    handleClickInit() {
      this.search_period = { value: "0d" };
      this.search_customer = "";
      this.search_address = "";
      this.search_symptom = "";
      this.search_charger = "";
      this.search_action = "";
      this.search_tel = "";
      this.search_desc = "";
      this.search_free_flag = "All";
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleCellClick(row, column) {
      if (!column.property) {
        return;
      }
      if (column.property === "customer_addr") {
        this.$emit("selectAddress", row.customer_addr);
      } else {
        this.handleClickButtonCopy(row, true);
      }
    },
    handleClickButtonCopy(row, modified = false) {
      if (!modified) {
        row.id = 0;
        row.request_date = this.util.getDate();
        row.service_date = null;
        row.charger = null;
        row.action = null;
      }
      this.selectedData = Object.assign({}, row);
      this.$emit("requestedForm", this.selectedData);
    },
    handleClickButtonSale(data) {
      this.selectedData = Object.assign({}, data);
      this.dialog_visible = true;
    },
    handleCompletedForm(result) {
      this.dialog_visible = false;
      if (!result) {
        return;
      }
      // this.loadData()
      this.loadDataBySearchWord();
    },
    // handleSelectionChange(selection) {
    //   this.selection = selection;
    // },
    handleClickedCreate() {
      this.$emit("requestedForm");
    },
    handleClickManualSale() {
      this.dialog2_visible = true;
    },
    handleCompletedForm2(result) {
      this.dialog2_visible = false;
      if (!result) {
        return;
      }
      // this.loadData()
      this.loadDataBySearchWord();
    },
    handleClickButtonContract(data) {
      this.selectedData = Object.assign({}, data);
      this.contract = {
        id: 0,
        service_id: data.id,
        zipcode: data.customer_zipcode,
        destination: data.customer_addr,
        charger: data.charger,
        customer_tel: data.customer_tel,
        contract_date: data.request_date,
        delivery_date: data.service_date,
        status_flag: "0",
        details: [],
      };
      this.api.selectContractByService(data.id).then((res) => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        if (res.data) {
          this.contract = res.data;
        }
        this.dialog2_visible = true;
      });
    },
    handleCompletedContractForm(data) {
      this.dialog2_visible = false;
      this.contract = data;
      let org = null;
      let is_deleted = false;
      if (typeof data === "object") {
        org = this.items.find((item) => item.id === data.service_id);
      } else {
        org = this.items.find((item) => item.id === this.selectedData.id);
        is_deleted = true;
      }
      if (!org) {
        return;
      }
      if (!is_deleted) {
        org.contract = data;
        org.price = data.price;
      } else {
        org.contract = null;
        org.price = 0;
      }
    },
    handleClickButtonCollect(data) {
      this.selectedData = Object.assign({}, data);
      this.api.selectContractByService(data.id).then((res) => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        if (!res.data) {
          return;
        }
        this.contract = res.data;
        this.dialog3_visible = true;
      });
    },
    handleChangeCollect() {
      // this.loadData();
      this.loadDataBySearchWord();
    },
    handleCompletedCollect() {
      this.dialog3_visible = false;
    },
    handleSearchWord() {
      this.fixed_search_customer = this.search_customer;
      this.fixed_search_address = this.search_address;
      this.fixed_search_symptom = this.search_symptom;
      this.fixed_search_action = this.search_action;
      this.fixed_search_charger = this.search_charger;
      this.fixed_search_tel = this.search_tel;
      this.fixed_search_desc = this.search_desc;
      this.fixed_search_free_flag = this.search_free_flag;
    },
    handleClickExcel() {
      this.$refs.table.downloadExcel();
    },
  },
};
</script>

<style lang="scss">
.ServiceList {
  .search-left-space {
    margin-left: 12px;
  }
  .search-top-space {
    margin-top: 12px;
  }
  .font-prop {
    font-weight: bold;
    font-size: 12px;
    margin-top: 2px;
    margin-right: 10px;
    text-align: right;
  }
}
</style>
